import ImagePerson from "@/components/functionals/ImagePerson.vue";
import formatterAutoMV from "@/components/functionals/formatterAutoMV.vue";
import { formatDate } from "@/utils";
export const AutoMVDetailcolumns = [
  {
    prop: "IdAutoMV",
    name: "ID",
    minWidth: 80,
    fixed: true,
    sortable: true
  },
  {
    prop: "UserId",
    label: "User ID",
    minWidth: 90,
    fixed: true,
    sortable: true
  },
  {
    prop: "EmployeeName",
    label: "Nombre del Empleado",
    minWidth: 200,
    fixed: true,
    formatter: ImagePerson,
    attrs: {
      imgKey: "ImagePerson"
    },
    sortable: true
  },
  {
    prop: "SupervisorName",
    label: "Quien califica",
    minWidth: 200,
    fixed: true,
    formatter: ImagePerson,
    attrs: {
      imgKey: "ImageSupervisor"
    },
    sortable: true
  },
  {
    prop: "Ranting",
    label: "Estado",
    width: 200,
    sortable: true,
    formatter: formatterAutoMV
  },
  {
    prop: "Ranting",
    label: "Calificación",
    width: 200,
    sortable: true,
    formatter: (props) => {
      if (props.Ranting != null) {
        return props.Ranting;
      }
      return 0;
    }
  },
  {
    prop: "RatingComment",
    label: "Comentario",
    width: 200,
    sortable: true,
    formatter: (props) => {
      if (props.RatingComment != null) {
        return props.RatingComment;
      }
      return "Sin comentario";
    }
  },
  {
    prop: "CreatedAt",
    label: "Fecha Creación",
    minWidth: 120,
    sortable: true,
    formatter: (props) => {
      // console.log(props)
      return formatDate(props.CreatedAt, "DD/MM/YYYY");
    }
  }
  // {
  //   prop: "month",
  //   label: "Mes",
  //   minWidth: 120,
  //   sortable: true
  // },
  // {
  //   prop: "year",
  //   label: "Año",
  //   minWidth: 120,
  //   sortable: true
  // }
];
export const AutoMVDetailAction = [
  {
    icon: "el-icon-view",
    label: "Ver",
    command: "view-auto-mv"
  },
  {
    icon: "el-icon-star-off",
    label: "Calificar",
    command: "edit-auto-mv",
    condition: (r) => r.IsSupervisor === true && r.Ranting === null
  }
];

export const AutoMVPendingAction = [
  {
    icon: "el-icon-view",
    label: "Ver",
    command: "view-auto-mv"
  },
  {
    icon: "el-icon-star-off",
    label: "Calificar",
    command: "edit-auto-mv"
  }
];
